import { graphql } from '../../../graphql/graphql';
import { weblinkFragment } from '../../../graphql/weblinkFragment';

export const searchResultsFragment = graphql(
  `
    fragment SearchResultsFragment on SearchPageResult {
      slugV2
      key
      reaLinkV2
      clickThroughTracking {
        pathname
        page
        element
        sourceType
      }
      address
      badge {
        text
        variant
      }
      priceV2 {
        display @include(if: $showPrice)
        sourceLevel
      }
      soldDate
      imageV2 {
        ... on SearchPageResult_Image {
          alt
          jpgUri: uri(width: 421, height: 237, imageMode: Crop, progressive: true)
          webpUri: uri(
            width: 421
            height: 237
            format: $imageFormatWebp
            imageMode: Crop
            progressive: true
          )
        }
        ... on PropertyPage_AerialImage {
          alt
          uri(width: FULL)
        }
      }
      features {
        title
        iconNameV2
        hoverTitle
        valueWithUnit
      }
      searchByImageButton {
        ... on WebLink {
          ...WebLink
        }
      }
    }
  `,
  [weblinkFragment],
);
